<template>
  <v-select
    class="px-5"
    id="my-sms-did"
    v-if="currentUser !== null && currentUser.smsCapable && smsDidsNumber.length > 1"
    v-model="smsDidsToFilter"
    :items="smsDidsNumber"
    :label="$t('chat.smsContextMenu.filterMySmsDid')"
    style="max-width: 300px;z-index: 999;"
    prepend-icon="mdi-sort-numeric-variant"
    item-value="value"
    item-text="display"
    @change="onChangeDid"
    multiple
    chips
  >
    <template v-slot:selection="{ item }">
      <v-chip>
        <span>{{ item.display }}</span>
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      {{ item.display }}
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChatLocalStorage from '@/api/chat'

export default {
  name: 'chat-phoneNumbersFilter',
  data () {
    return {
      smsDidsToFilter: []
    }
  },
  created () {
    const smsFilters = ChatLocalStorage.smsFilters()
    if (smsFilters) {
      this.smsDidsToFilter = smsFilters
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'chat/authenticatedRocketChatUser',
      smsDids: 'chat/smsDids'
    }),
    smsDidsNumber: function () {
      const dids = []
      this.smsDids.forEach(did => {
        dids.push({ display: did.formatted_did, value: did.did })
      })
      return dids
    }
  },
  methods: {
    ...mapActions({
      filterSMS: 'chat/filterSMS'
    }),

    findDidId (selectedDid) {
      let foundDid = null
      this.smsDids.find((did) => {
        if (did.formatted_did === selectedDid) {
          foundDid = did
        }
      })
      return foundDid.id
    },

    onChangeDid (selectedDids) {
      const plainDids = []
      selectedDids.forEach(formattedDid => {
        plainDids.push(formattedDid.replace(/\D/g, ''))
      })
      this.filterSMS(plainDids)
    }
  }
}
</script>

<style scoped>
  .v-text-field >>> label {
    font-size: 0.8em;
  }
</style>
